export const savePlaylistExpirationDate = async (exp_date: any) => {
    const date = new Date(exp_date * 1000); // Multiply by 1000 if it's in seconds
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    localStorage.setItem('@playlist_exp_date', formattedDate);
}
